import { coefAccIVA, coefConsTax } from '../general'

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set(state, [variable, value]) {
    state[variable] = value
  },
  setItems(state, items) {
    state.cart.items = items
  },
  pushProductToCart(state, product) {
    delete product['_toggled']
    delete product['_toggledEditPrice']
    product['cantidad'] = product['cantidad'] ? product['cantidad'] : 1
    product['comentarios'] = product['comentarios'] ? product['comentarios'] : ""
    state.cart.items.push(product)
  },
  incrementItemQuantity(state, product) {
    const cartItem = state.cart.items.find(item => item['id_Producto'] === product['id_Producto'])
    cartItem['cantidad']++
  },
  popProductFromCart(state, product) {
    const cartItemIndex = state.cart.items.findIndex(item => item['id_Producto'] === product['id_Producto'])
    state.cart.items.splice(cartItemIndex, 1)
  },
  decrementItemQuantity(state, product) {
    const cartItem = state.cart.items.find(item => item['id_Producto'] === product['id_Producto'])
    cartItem['cantidad']--
  },
  updateItemQuantity(state, [value, product]) {
    // console.log(value, product)      
    const cartItem = state.cart.items.find(item => item['id_Producto'] === product['id_Producto'])
    cartItem['cantidad'] = value
  },
  updateProductPriceInCart(state, [value, product]) {
    const cartItem = state.cart.items.find(item => item['id_Producto'] === product['id_Producto'])
    cartItem['valor_Producto'] = value
  },
  calculateProductsCost(state) {
    state.cart.productsCost = state.cart.items.reduce(((acc, item) => {
      return parseFloat(acc) + (coefAccIVA(item).realCost * parseFloat(item['cantidad']))
    }), 0)

  },
  calculateIVACost(state) {
    state.cart.IVACost = state.cart.items.reduce(((acc, item) => {
      return parseFloat(acc) + (parseFloat(item['cantidad']) * coefAccIVA(item).ivaTax)
    }), 0)
  },
  calculateConsTax(state) {
    state.cart.consTax = state.cart.items.reduce(((acc, item) => {
      return parseFloat(acc) + (parseFloat(item['cantidad']) * coefConsTax(item))
    }), 0)
  },
  resetCart(state) {
    state.cart = {
      productsCost: 0,
      IVACost: 0,
      consTax: 0,
      items: []
    }
  },
  resetQuote(state) {
    state.quote = {
      directorio: '',
      orden_Compra: ''
    }
  },
  updateQuote(state, newQuoteState) {
    Object.keys(newQuoteState).forEach((key) => {
      state.quote[key] = newQuoteState[key]
    })
  },
  updateItemComments(state, [value, product]) {
    const cartItem = state.cart.items.find(item => item['id_Producto'] === product['id_Producto'])
    cartItem['comentarios'] = value
  },
  setDependency(state, dependency) {
    state.user.dependency = dependency
  },
  setAlert(state, { color, message, show }) {
    state.alert.color = color
    state.alert.message = message
    state.alert.show = show
  },
  setAppVersion(state, { version, hash }) {
    state.app.version = version
    state.app.hash = hash
  },
  setUserValue(state, [key, value]) {
    state.user[key] = value
  },
  setMInterval(state, [action, value]) {
    console.log(action, value)
    if (action == 'add') {
      state.mInterval = value
    }

    if (action == 'cancel') {
      clearInterval(state.mInterval)
    }
  }
}

export default mutations